import React, {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import clsx from 'clsx';
import {Box} from '@mui/material';
import HelpPopover from '../../ui/HelpPopover';
import instance from '../../instance';
import './nomenclature.css';

interface INomenclatureTemplate {
    setCurrentPageClass: React.Dispatch<React.SetStateAction<string>>;
    children: React.ReactNode;
    isAdmin?: boolean;
    userId: number | null;
}

export default function NomenclatureTemplate({children, setCurrentPageClass, isAdmin, userId}: INomenclatureTemplate) {
    const [serviceCenterStatus, setServiceCenterStatus] = useState<{
        is_service_center: boolean;
        is_parent_service_center_exist: boolean;
    } | null>(null);

    useEffect(() => {
        setCurrentPageClass('bg nomenclature');
    }, [setCurrentPageClass]);

    useEffect(() => {
        const fetchServiceCenterStatus = async () => {
            if (!userId) return;

            try {
                const response = await instance.post('/LK', {
                    method: 'CheckParentServiceCenter',
                    params: {user_id: Number(userId)},
                });

                if (!response.data.error && response.data.result) {
                    setServiceCenterStatus(response.data.result);
                } else {
                    setServiceCenterStatus({is_service_center: false, is_parent_service_center_exist: false});
                }
            } catch (error) {
                setServiceCenterStatus({is_service_center: false, is_parent_service_center_exist: false});
            }
        };

        void fetchServiceCenterStatus();
    }, [userId]);

    const links = [
        {
            label: isAdmin ? (
                <>
                    Номенклатура ЦТО
                    <HelpPopover
                        content={
                            <>
                                В&nbsp;данном разделе можно управлять только собственной номенклатурой. Управление номенклатурой мерчантов
                                (клиентов) осуществляется в&nbsp;их&nbsp;собственном личном кабинете.
                            </>
                        }
                        style={{padding: 0}}
                    />
                </>
            ) : (
                'Номенклатура'
            ),
            path: '/nomenklatura',
        },
        ...(isAdmin ? [{label: 'Тиражирование номенклатуры' as React.ReactNode, path: '/nomenklatura/replication'}] : []),
        {label: 'Сверка с НКТ' as React.ReactNode, path: '/nomenklatura/ntin'},
    ];

    const location = useLocation();

    const routeMap: Record<string, any> = {
        '/nomenklatura': {title: 'Номенклатура', baseRoute: '/nomenklatura'},
        '/nomenklatura/replication': {title: 'Тиражирование номенклатуры', baseRoute: '/nomenklatura/replication'},
        '/nomenklatura/ntin': {title: 'Сверка с НКТ', baseRoute: '/nomenklatura/ntin'},
    };

    return (
        <section className={'content'}>
            <div className={'header'}>
                <h1 className={'title'}>
                    <span>Номенклатура&nbsp;</span>
                </h1>
            </div>
            <nav className="nav-tabs">
                {links.map(link => (
                    <Link
                        key={link.path}
                        to={link.path}
                        className={clsx('tab-link', {active: routeMap[location.pathname]?.baseRoute === link.path})}
                    >
                        {link.label}
                    </Link>
                ))}
            </nav>
            {!isAdmin &&
                serviceCenterStatus &&
                !serviceCenterStatus.is_service_center &&
                !serviceCenterStatus.is_parent_service_center_exist && (
                    <Box
                        sx={{
                            padding: 2,
                            backgroundColor: '#ffdddd',
                            marginBottom: 2,
                            width: '100%',
                            lineHeight: '140%',
                            boxSizing: 'border-box',
                        }}
                    >
                        Ваш аккаунт не привязан к центру технического обслуживания. Сервис «Номенклатура» может быть отключен.
                        <br />
                        Пожалуйста, обратитесь в ваш ЦТО или выберите наиболее удобный из{' '}
                        <a href={'https://streampay.kkmport.kz/merchantinfo'} target={'_blank'}>
                            предложенного списка
                        </a>
                        .
                    </Box>
                )}
            <div className={'workspace'}>
                <section className={'content'}>{children}</section>
            </div>
        </section>
    );
}
